import { Component, EventEmitter, Input, OnInit, Output, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { MatInput } from '@angular/material/input';
import { SharedComponentsSysTextService } from '@core/services/shared-components-sys-text.service';
import { FormControl, FormGroup } from '@angular/forms';

@Component({
    selector: 'app-input-field',
    templateUrl: './input-field.component.html',
    styleUrls: ['./input-field.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class InputFieldComponent implements OnInit {
  static readonly componentName = 'InputFieldComponent';

  // #region Properties (12)
  
  @Input() public ariaLabel: string; // the name screen readers use instead of the label, for a label repeated in one form
  @Input() public autocomplete: string = 'off'; // a token such as 'given-name' or 'email' on fields for the user's own details
  @Input() public control: FormControl;
  @Input() public group: FormGroup;
  @Input() public hideIconSpace: boolean;
  @Input() public hint: string;
  @Input() public icon: string;
  @ViewChild('input') public input: MatInput;
  @Input() public inputType: string = 'text';
  @Input() public isCurrency: number;
  @Input() public isHintHighlighted: boolean = true;
  @Input() public isHintWarning: boolean = false;
  @Input() public label: string;
  @Input() public minNumAllowed = 0;
  @Input() public patternError: string;
  @Input() public msErrorKey: string;
  @Input() public customMsError: string;
  @Input() public removeLabelCasePipe: boolean = false;
  @Input() public customRequiredMessage: string;
  @Input() public info: string;
  @Input() public retainDefaultDisabled: boolean = false;
  @Output() emitInputChange = new EventEmitter<string>();
  public sysText: any;
  public _isDisabled: boolean;

  // #endregion Properties (12)

  // #region Constructors (1)

  constructor(private text: SharedComponentsSysTextService) {}

  // #endregion Constructors (1)

  // #region Public Methods (1)

  @Input() public set isDisabled(isDisabled: boolean) {
    isDisabled ? this.control.disable() : this.control.enable();
    this._isDisabled = isDisabled;
  }

  public ngOnInit(): void {
    this.sysText = this.text.sysText[this.text.templates.inputField];
  }

  onEmitInputChange(event: any) {
    this.emitInputChange.emit(event.target.value);
  }

  // #endregion Public Methods (1)
}
